
export const ROLE_GROUP_MEMBER = 1;
export const ROLE_ADMINISTRADOR = 2;
export const ROLE_ESTUDIANTE = 3;
export const ROLE_MAESTRO = 4;
export const ROLE_STAFF = 5;
export const ROLE_CAPTURISTA = 6;
export const ROLE_PROMOTOR = 14;
export const ROLE_ACADEMY = 15;
export const ROLE_ADMIN_DEGREE = 20;
export const ROLE_ADMIN_RECEPCION_DOCS = 23;
export const ROLE_SOPORTE_D2L = 27;

//PERMISSIONS
export const PERMISSION_MY_TALISIS = 24;
export const PERMISSION_ADMIN_DEGREE_CERT = 36;
export const PERMISSION_VENTAS = 42;
export const PERMISSION_ASSISTANT_TALI = 44;
export const PERMISSION_CHATTALI = process.env.REACT_APP_ENV_V2 === 'production' ? 45 : 46;